import { useFeatureIsOn } from '@growthbook/growthbook-react';

/**
 * GrowthBook feature key for the "Show more & Infinite scroll" A/B test
 * (DEV-6156). Boolean flag driven by an experiment rule: 100% of users,
 * 50/50 split, sticky bucketed per user via the cookie-based sticky bucket
 * service in `ABProvider`.
 */
export const SHOW_MORE_INFINITE_SCROLL_FEATURE = 'show-more-infinite-scroll';

/**
 * 'A' — control: current pagination and footer behaviour.
 * 'B' — refined "Show more" + infinite scroll, with the footer hidden while
 *       more results load and revealed at the true end of the results.
 */
export type ShowMoreVariant = 'A' | 'B';

/**
 * Which group of the "Show more & Infinite scroll" experiment the user is in.
 * All listing pages in the test read the variant through this hook so
 * bucketing stays consistent — don't call `useFeatureIsOn` with the flag key
 * directly.
 *
 * When the experiment is off or the flag can't be loaded, the flag evaluates
 * to false, so this falls back to 'A' (control) and the site behaves exactly
 * as it does today.
 */
export const useShowMoreVariant = (): ShowMoreVariant =>
  useFeatureIsOn(SHOW_MORE_INFINITE_SCROLL_FEATURE) ? 'B' : 'A';
